export default __webpack_public_path__ + "static/media/hotword.75b596c2.png";